import React from 'react'
import { Spinner } from 'react-bootstrap'

type TSpinerSize = 'small' | 'medium' | 'large'

interface IMySpinnerProps {
  size?: TSpinerSize
}

const styleColor = {
  color: 'var(--color-grey-input)',
  borderRightColor: 'var(--color-blue)',
}

const styleSmall = { width: '15px', height: '15px' }
const styleMedium = { width: '1.5rem', height: '1.5rem' }
const styleLarge = { width: '2rem', height: '2rem' }

const getStyle = (size?: TSpinerSize) => {
  if (size === 'small') {
    return { ...styleColor, ...styleSmall }
  } else if (size === 'medium') {
    return { ...styleColor, ...styleMedium }
  } else if (size === 'large') {
    return { ...styleColor, ...styleLarge }
  } else {
    return { ...styleColor, ...styleLarge }
  }
}

const SpanSpinner: React.FC<IMySpinnerProps> = ({ size }) => {
  return (
    <span>
      <Spinner animation='border' style={getStyle(size)} />
    </span>
  )
}
export default SpanSpinner
